class PP_Newsletter {
  constructor () {
      if (!$('.pp-newsletter-form, .wpcf7, .encharge-form').length) {
          return;
      }

      this.readUtmFromCookies();
  }

  readUtmFromCookies () {
      let forms = $('.pp-newsletter-form, .wpcf7, .encharge-form');
      
      if (!forms.length) {
          return;
      }

      let utmSource = window.ppUtmData.utm_source;
      let utmMedium = window.ppUtmData.utm_medium;
      let utmCampaign = window.ppUtmData.utm_campaign;
      let utmContent = window.ppUtmData.utm_content;

      for (let i = 0; i < forms.length; i++) {
        let form = forms.eq(i);
        
        if (utmSource) {
            form.find('input[name="utm_source"]').val(utmSource);
            form.find('input.enchagre-form-v2[name="UTMSource"]').val(utmSource);
        }

        if (utmMedium) {
            form.find('input[name="utm_medium"]').val(utmMedium);
            form.find('input.enchagre-form-v2[name="UTMMedium"]').val(utmMedium);
        }

        if (utmCampaign) {
            form.find('input[name="utm_campaign"]').val(utmCampaign);
            form.find('input.enchagre-form-v2[name="UTMCampaign"]').val(utmCampaign);
        }

        if (utmContent) {
            form.find('input[name="utm_content"]').val(utmContent);
            form.find('input.enchagre-form-v2[name="UTMContent"]').val(utmContent);
        }
      }
  }
}
